import React from 'react';
import MaskedInput from 'react-text-mask';
import TextField, { TextFieldProps } from '../text-field/TextField';

interface TextMaskCustomProps {
  inputRef: (ref: HTMLInputElement | null) => void;
}

const TextMaskCustom = (textMaskProps: TextMaskCustomProps | any) => {
  const { inputRef, ...other } = textMaskProps;
  const charRegex = /[A-Z | \d]/i;
  const maxLength = other.maxLength || 4;
  return (
    <MaskedInput
      {...other}
      data-testid={'alphaNumericTextField'}
      type={'text'}
      name={textMaskProps.name || 'alphaNumeric'}
      ref={(ref: any) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={Array(maxLength).fill(charRegex)}
      guide={false}
      showMask
    />
  );
};

export default React.forwardRef(
  (props: TextFieldProps | any, ref?: React.Ref<HTMLInputElement>) => {
    const label = props.label || '';

    return (
      <TextField
        label={label}
        onBlur={props.onBlur}
        ref={ref}
        disabled={!!props.disabled}
        style={props.style || { width: '100%' }}
        InputProps={{
          inputComponent: TextMaskCustom,
        }}
        name={props.name || 'alphaNumeric'}
        margin={'normal'}
        error={!!props.error}
        helperText={props.helperText || props.error}
        onChange={props.onChange}
        defaultValue={props.defaultValue || null}
        {...props}
      />
    );
  },
);
